export default "__VITE_ASSET__tREADnyJ__"